import { parse as parseDate } from 'date-fns'

import { PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'
import { isDateValid, isLaterThanOrEqualTo } from 'utils/datetime'

import type { PeriodeKinerja } from 'types/kinerja'
import type { TStatePelaksanaan } from 'types/kinerja-pelaksanaan'

export function isAfterStep(
  stepA: TStatePelaksanaan,
  stepB: TStatePelaksanaan
) {
  const stepAOrder = PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[stepA]?.order ?? -1
  const stepBOrder =
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[stepB]?.order ?? Infinity

  return stepAOrder > stepBOrder
}

export function getPelaksanaanDate(periodeKinerja: PeriodeKinerja[]): string {
  const pelaksanaanDate =
    periodeKinerja.find(({ key }) => key === 'persiapan')?.value ?? ''

  return pelaksanaanDate
}

export function isDateStarted(periodeKinerja: PeriodeKinerja[]): boolean {
  const pelaksanaanDate = getPelaksanaanDate(periodeKinerja)

  if (!isDateValid(pelaksanaanDate)) return false

  const parsedPelaksanaanDate = parseDate(
    pelaksanaanDate,
    'yyyy-MM-dd',
    new Date()
  )
  const isPelaksanaanDatePassed = isLaterThanOrEqualTo(parsedPelaksanaanDate)

  return isPelaksanaanDatePassed
}
